export default "__VITE_ASSET__02e259de__"